import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-49da7194"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0,
  ref: "question"
};
const _hoisted_2 = {
  class: "one-nr"
};
const _hoisted_3 = {
  class: "title"
};
const _hoisted_4 = {
  class: "decs"
};
const _hoisted_5 = {
  class: "one-nr"
};
const _hoisted_6 = {
  class: "title"
};
const _hoisted_7 = {
  class: "decs"
};
const _hoisted_8 = {
  class: "one-nr"
};
const _hoisted_9 = {
  class: "title"
};
const _hoisted_10 = ["innerHTML"];
const _hoisted_11 = {
  class: "title"
};
const _hoisted_12 = {
  class: "one-step"
};
const _hoisted_13 = {
  key: 0,
  class: "btngroup"
};

const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-top",
  style: {
    "font-size": "22px"
  }
}, null, -1));

const _hoisted_15 = [_hoisted_14];
const _hoisted_16 = {
  class: "chat-btn"
};

const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "el-icon-chat-dot-round",
  style: {
    "font-size": "16px",
    "position": "relative"
  }
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "dian"
})], -1));

const _hoisted_18 = {
  style: {
    "position": "absolute",
    "right": "35px",
    "bottom": "auto",
    "margin-top": "100px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Ticket = _resolveComponent("Ticket");

  const _component_StepType = _resolveComponent("StepType");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_Ticket, {
    show: $data.ticket.show,
    "onUpdate:show": _cache[0] || (_cache[0] = $event => $data.ticket.show = $event),
    questionType: $data.ticket.questionType,
    question: $data.ticket.question,
    questionRecord: $data.ticket.questionRecord
  }, null, 8, ["show", "questionType", "question", "questionRecord"]), _ctx.questionTemp ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(_ctx._t('title')), 1), _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.questionTemp.title), 1)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString(_ctx._t('linkItem')), 1), _createElementVNode("div", _hoisted_7, _toDisplayString($options.getItemsName(_ctx.questionTemp.item)), 1)]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, _toDisplayString(_ctx._t('description')), 1), _createElementVNode("div", {
    class: "decs",
    innerHTML: _ctx.questionTemp.description
  }, null, 8, _hoisted_10)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stepTemp, (_questionStep, _questionStepIndex) => {
    return _openBlock(), _createElementBlock("div", {
      class: "one-step",
      key: _questionStepIndex
    }, [_questionStep ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [_createElementVNode("div", _hoisted_11, _toDisplayString(_ctx._t("step")) + _toDisplayString(Number(_questionStepIndex) + 1), 1), _createElementVNode("div", null, [_createVNode(_component_StepType, {
      question: _ctx.questionTemp,
      step: _questionStep,
      disabled: _questionStepIndex != _ctx.stepTemp.length - 1 || $options.stepEnd
    }, null, 8, ["question", "step", "disabled"])])], 64)) : _createCommentVNode("", true)]);
  }), 128)), _createElementVNode("div", _hoisted_12, [$options.stepEnd ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createElementVNode("div", {
    class: _normalizeClass([$options.btnClass($data.solvedDisabled || $data.unsolvedDisabled, $data.unsolvedDisabled), "btn"]),
    onClick: _cache[1] || (_cache[1] = $event => $options.clickChatNow(_ctx.questionTemp))
  }, _toDisplayString(_ctx._t("unsolvedAndChatNow")), 3), _createElementVNode("div", {
    class: _normalizeClass([$options.btnClass($data.solvedDisabled || $data.unsolvedDisabled, $data.solvedDisabled), "btn"]),
    onClick: _cache[2] || (_cache[2] = $event => $options.clickSolved(_ctx.questionTemp))
  }, _toDisplayString(_ctx._t("solved")), 3), _createElementVNode("div", {
    class: _normalizeClass(["btn", $options.btnClass()]),
    onClick: _cache[3] || (_cache[3] = (...args) => $options.clickBackPreStep && $options.clickBackPreStep(...args))
  }, _hoisted_15, 2)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", {
    onClick: _cache[4] || (_cache[4] = $event => $options.clickChatNow(_ctx.questionTemp))
  }, [_hoisted_17, _createTextVNode(" " + _toDisplayString(_ctx._t("needHelp")), 1)])]), _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx._t("Onlinetimeperiod")), 1)])], 512)) : _createCommentVNode("", true)], 64);
}